import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, Button, HStack, useMultiStyleConfig, useMediaQuery} from '@chakra-ui/react'
import CustomLink from '../../../custom-link'
import {TextTitleDescription} from '../../text-title-description'
import {remCalc} from '../../../../theme/_utils'
import {ChevronRight} from '../../../icons'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {safeBuildUrl, getGlobalLink} from '../../../../utils/contentstack-utils'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY} from '../../../../brand'
import {useProducts} from '@salesforce/commerce-sdk-react'

const MoodBoardCard = ({textBlock, images, cta}) => {
    const isKenwood = BRAND_KEY === 'kenwood'
    const categoriesData = useGetCategoriesData()
    const {data: productsData} = useProducts({
        parameters: {
            ids: cta?.productsfcc?.data?.length > 0 ? cta.productsfcc.data[0].id : '',
            allImages: false,
        },
    })
    const {buildUrl, locale} = useMultiSite()

    const {url, label, isAbsolute} = getGlobalLink({
        link: cta,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })
    const [isSmallTablet] = useMediaQuery(
        `(min-width: ${remCalc(450)}) and (max-width: ${remCalc(768)})`,
    )

    const styles = useMultiStyleConfig('Moodboard', {
        isSmallTablet,
    })

    const damImage = useDamImage(images)

    return (
        <CustomLink
            isExternal={isAbsolute}
            href={isAbsolute ? url : safeBuildUrl(url, buildUrl)}
            _hover={{textDecoration: 'none'}}
            data-testid="moodboard-card-link"
        >
            <Flex
                backgroundImage={
                    damImage.url
                        ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%), url(${damImage.url})`
                        : 'none'
                }
                {...styles.cardContainer}
                data-testid="moodboard-container"
            >
                <Flex {...styles.textContentContainer} data-testid="moodboard-text-container">
                    <TextTitleDescription
                        title={textBlock?.title}
                        {...styles.moodboardTextTitleDescription}
                    >
                        {textBlock?.body_copy}
                    </TextTitleDescription>
                    {label && (
                        <Button {...styles.moodboardButton} aria-label={label} tabIndex={0}>
                            <HStack {...styles.moodboardButtonStack}>
                                <Text as="span" {...styles.moodboardButtonText}>
                                    {label}
                                </Text>
                                {!isKenwood && (
                                    <ChevronRight
                                        aria-label="right icon"
                                        {...styles.moodboardChevronIcon}
                                    />
                                )}
                            </HStack>
                        </Button>
                    )}
                </Flex>
            </Flex>
        </CustomLink>
    )
}

MoodBoardCard.propTypes = {
    textBlock: PropTypes.shape({
        title: PropTypes.string,
        body_copy: PropTypes.string,
    }),
    images: PropTypes.object,
    cta: PropTypes.shape(),
}

export default MoodBoardCard
